import { Star, StarHalf, StarOff } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./../components/ui/tooltip";

type StarRatingProps = {
  over: number;
  under?: number;
  className?: string;
};

export function StarRating({
  over,
  under = 5,
  className = "",
}: StarRatingProps) {
  const fullStars = Math.floor(over);
  const decimal = over - fullStars;
  const shouldRenderHalf = decimal >= 0.2 && decimal < 0.8;
  const stars: JSX.Element[] = [];

  for (let i = 0; i < fullStars; i++) {
    stars.push(
      <Star
        key={`full-${i}`}
        className="text-yellow-500 fill-yellow-400 w-5 h-5"
      />
    );
  }

  if (shouldRenderHalf) {
    stars.push(
      <StarHalf
        key="half"
        className="text-yellow-500 fill-yellow-400 w-5 h-5"
      />
    );
  }

  while (stars.length < under) {
    stars.push(
      <Star
        key={`empty-${stars.length}`}
        className="text-muted-foreground w-5 h-5"
      />
    );
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className={`flex gap-1 ${className}`}>{stars}</div>
        </TooltipTrigger>
        <TooltipContent>
          <p>
            {over} / {under}
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
